<template>
    <div class="content-filters">
        <div class="wrapper">

          <nav v-if="tabsFilter" class="content-filters-tabs">
            <ul>
              <li v-for="item in tabsFilter" v-bind:class="paginatorValue.filter == item.slug ? 'is-active' : ''" v-if="(item.slug == 'only_trashed' && $store.getters.user.role_level <= 2) || item.slug != 'only_trashed'">
                <a @click="setFilterVue(item.slug)"><span>{{ item.name }}</span></a></li>
            </ul>
          </nav>

            <div class="search">

              <div v-if="showQuery">
                <input type="text" placeholder="Recherche" v-model="internalValue.query"/>
                <button class="bt-search"><icon name="search-sm" v-show="internalValue.query === ''"/></button>
                <button class="bt-clear" @click="clearSearch"><icon name="x-close" v-show="internalValue.query !== ''"/></button>
              </div>

              <widget-dropdown v-model="internalValue.period" :options="periods" :callback="filterByPeriodVue" v-if="activeAdvancedFilterVue"></widget-dropdown>

              <div class="advanced-filters" @click="displayAdvancedFilters = !displayAdvancedFilters" v-if="internalValue.inputs.length || activeClientFilterVue">
                <icon name="settings-04"/>
              </div>

            </div>
            <div class="search-advanced" v-if="internalValue.inputs.length || activeClientFilterVue" v-show="displayAdvancedFilters">

                <!-- CUSTOM FILTERS FORM -->
                <div v-for="attribute in internalValue.inputs" v-if="internalValue && internalValue.inputs">
                    <div v-if="!attribute.has_languages">
                        <form-text :label="attribute.name" @input="setInputsValueVue" v-model="internalValue[attribute.slug]" v-if="attribute.type == 'text'" :required="attribute.mandatory"></form-text>
                        <form-text :label="attribute.name" @input="setInputsValueVue" v-model="internalValue[attribute.slug]" v-if="attribute.type == 'email'" :required="attribute.mandatory"></form-text>
                        <form-phone :label="attribute.name" @input="setInputsValueVue" v-model="internalValue[attribute.slug]" v-if="attribute.type == 'phone'" :required="attribute.mandatory"></form-phone>
                        <form-textarea :label="attribute.name" @input="setInputsValueVue" v-model="internalValue[attribute.slug]" v-if="attribute.type == 'textarea'" :required="attribute.mandatory"></form-textarea>
                        <form-select :label="attribute.name" @input="setInputsValueVue" :multiple="internalValue[attribute.slug]" v-model="attribute.value" id="id" :options="attribute.options" v-if="attribute.type == 'select'" :required="attribute.mandatory"></form-select>
                        <form-select :label="attribute.name" @input="setInputsValueVue" :multiple="internalValue[attribute.slug]" v-model="attribute.value" :default="attribute.country_id" :options="$store.state.countries" v-if="attribute.type == 'country'" :required="attribute.mandatory"></form-select>
                        <form-toggle :label="attribute.name" @input="setInputsValueVue" v-model="internalValue[attribute.slug]" v-if="attribute.type == 'toggle'"></form-toggle>
                        <form-autocomplete :label="attribute.name"  @input="setInputsValueVue" multiple="false" v-model="attribute.value" :service="attribute.service" icon="icon-icon_person" v-if="attribute.type == 'autocomplete'"></form-autocomplete>
                    </div>
                </div>

                <div class="form-advanced-entity" v-if="activeClientFilterVue">
                    <entity v-model="entity" :default="internalValue.clientFilter.client_id" :create="false" :callback="updateEntity"></entity>
                </div>

                <div class="form-advanced-filter" v-if="showAdvancedFilterVue">
                    <span>Filtrer par date</span>
                    <div class="date-filters">
                        <form-date label="du" time="00:00:00" hideTime="true" v-model="internalValue.advancedFilters.dateFilter.start_at" format="yyyy-MM-dd"></form-date>
                        <form-date label="au" time="23:59:59" hideTime="true" v-model="internalValue.advancedFilters.dateFilter.end_at" format="yyyy-MM-dd"></form-date>
                    </div>
                </div>

            </div>

        </div>
    </div>
</template>

<script>

export default {
    name: 'Filters',
    props: ['value','paginator','tabs','menus','activeAdvancedFilter','activeQuery','activeDateFilter','activeClientFilter','activeTabs','activeNav','dataSelectedFilter','selectedClassName','localesProp'],
    data: function () {
        return {
            entity: null,
            showQuery: null,
            selectedObject: null,
            internalValue: {
                query: '',
                lastFilter: '',
                period: '',
                clientFilter: {
                    client: null,
                    client_id: null,
                    client_type: null,
                    addresses: null
                },
                advancedFilters: {
                    dateFilter: {
                        start_at: '',
                        end_at: ''
                    }
                }
            },
            locales: null,
            paginatorValue: {
                filter: '',
                sort: '',
                order: '',
                page: 1,
                last: 1,
                total: 1,
                listing: ''
            },
            periods: [
                {id: 'all', label: 'Tout'},
                {id: 'last_7days', label: '7 derniers jours'},
                {id: 'current_month', label: 'Ce mois'},
                {id: 'last_month', label: 'Le mois dernier'},
                {id: 'since_1_month', label: '30 derniers jours'},
                {id: 'since_3_months', label: '90 derniers jours'},
                {id: 'current_year', label: 'Cette année'},
                {id: 'last_year', label: 'Depuis 12 mois'},
                {id: 'custom', label: 'Personnalisé'},
            ],
            navigation: [],
            tabsFilter: [],
            selectFilter: null,
            activeNavVue: null,
            activeTabsVue: null,
            activeClientFilterVue: false,
            activeDateFilterVue: false,
            activeAdvancedFilterVue: false,
            showAdvancedFilterVue: false,
          displayAdvancedFilters: false
        }
    },
    created: function() {

        this.internalValue = this.value;
        this.tabsFilter = this.tabs;
        this.paginatorValue = this.paginator;
        this.navigation = this.menus;
        this.locales = this.localesProp;
        this.showQuery = !this.activeQuery && (this.activeQuery == 'false' || this.activeQuery == false) ? false : true;
        this.internalValue.advancedFilters.selectClass = this.selectedClassName;
        this.activeClientFilterVue = this.activeClientFilter && (this.activeClientFilter == 'true' || this.activeClientFilter == true) ? true : false;
        this.activeDateFilterVue = this.activeDateFilter && (this.activeDateFilter == 'true' || this.activeDateFilter == true) ? true : false;
        this.activeAdvancedFilterVue = this.activeAdvancedFilter && (this.activeAdvancedFilter == 'true' || this.activeAdvancedFilter == true) ? true : false;
        this.selectFilter = this.dataSelectedFilter ? this.dataSelectedFilter : {};

        console.log('ACTIVE USER' + this.activeClientFilterVue);

    },
    methods: {
        filterByPeriodVue: function(period)
        {
            this.$emit('filterByPeriod', period);
        },
        setFilterVue: function(slug) {
            this.$emit('setFilter', slug);
        },
        setInputsValueVue: function(item) {
            this.$emit('setInputsValue', item);
        },
        updateEntity: function(item)
        {
            if( item )
            {
                this.internalValue.clientFilter.client_type = item.type
                this.internalValue.clientFilter.client = item.entity
                this.internalValue.clientFilter.addresses = item.addresses
            }
        },
      clearSearch: function() {
          this.internalValue.query = ""
      },
        showAdvancedFilter: function (){
            if(this.showAdvancedFilterVue) {
                this.showAdvancedFilterVue = false;
            }else{
                this.showAdvancedFilterVue = true;
            }
        }
    },
    watch: {
        'selectedObject' : function ( val ){
            this.internalValue.advancedFilters.selectValue = val.id;
        },
        'internalValue.period' : function ( val ){
            if(val == 'custom') {
                this.showAdvancedFilterVue = true
            }else{
                this.showAdvancedFilterVue = false;
            }
        }
    }
}

</script>



// WEBPACK FOOTER //
// src/components/Filters.vue